/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMinervalGridDto
 */
export interface FcbMinervalGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbMinervalGridDto
     */
    idApprenant?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMinervalGridDto
     */
    anneeScolaire?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMinervalGridDto
     */
    idInscription?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbMinervalGridDto
     */
    codeInscription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMinervalGridDto
     */
    minerval?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMinervalGridDto
     */
    idClasse?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMinervalGridDto
     */
    codeClasse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMinervalGridDto
     */
    nomClasse?: string | null;
}

/**
 * Check if a given object implements the FcbMinervalGridDto interface.
 */
export function instanceOfFcbMinervalGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMinervalGridDtoFromJSON(json: any): FcbMinervalGridDto {
    return FcbMinervalGridDtoFromJSONTyped(json, false);
}

export function FcbMinervalGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMinervalGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
        'idInscription': !exists(json, 'idInscription') ? undefined : json['idInscription'],
        'codeInscription': !exists(json, 'codeInscription') ? undefined : json['codeInscription'],
        'minerval': !exists(json, 'minerval') ? undefined : json['minerval'],
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'codeClasse': !exists(json, 'codeClasse') ? undefined : json['codeClasse'],
        'nomClasse': !exists(json, 'nomClasse') ? undefined : json['nomClasse'],
    };
}

export function FcbMinervalGridDtoToJSON(value?: FcbMinervalGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'anneeScolaire': value.anneeScolaire,
        'idInscription': value.idInscription,
        'codeInscription': value.codeInscription,
        'minerval': value.minerval,
        'idClasse': value.idClasse,
        'codeClasse': value.codeClasse,
        'nomClasse': value.nomClasse,
    };
}

